require('./accountSettlementsTableRow.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { Link } = require('react-router-dom');
//@core
const { getLanguage } = require('core/i18n').i18n;
// @ helpers
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const DateHelper = require('utilities/dateHelper');
// @ commons
const { FormattedText } = require('core/i18n').i18n;
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { HYPHEN } = require('constants/index');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const DATE_FORMAT_TYPES = require('commonsConstants/dateFormatTypes');

class AccountSettlementsTableRow extends React.Component {

    constructor(props){
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    formatDateFromPeriod(dateStr, originCountry) {
         return DateHelper.buildFormattedDate(dateStr, DATE_FORMAT_TYPES[originCountry.toLowerCase()].DATE_FORMAT);
    }

    render() {
        const {
            id,
            immScreen,
            immTransaction,
            originCountry
        } = this.props;

        const settlementId = immTransaction.get('id');
        const pathToStatementDetail = `${window.location.pathname}/${settlementId}`; //TODO: find a better way to identify if we're in credits flow o accounts flow
        const plainAmountObject = getPlainAmountObject(immTransaction.get('dueAmount'));
        const plainAmountCreditObject = getPlainAmountObject(immTransaction.get('creditAmount'));
        const language = getLanguage();

        let dateFrom, dateTo, dueAmount, creditAmount;

        if (immTransaction) {
            dateFrom = this.formatDateFromPeriod(immTransaction.get('dateFrom'), originCountry);
            dateTo = this.formatDateFromPeriod(immTransaction.get('dateTo'), originCountry);

            if (immTransaction.get('showDue')){
                dueAmount = (<OneLineSymbolAmount
                    amountObject={plainAmountObject}
                    language={language}
                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                />)
            } else {
                creditAmount = (<OneLineSymbolAmount
                    amountObject={plainAmountCreditObject}
                    language={language}
                    amountObjectFormatted={formatAmountObject(plainAmountCreditObject, true)}
                />)
            }
        }

        const dateLink = (
            <Link
                to={pathToStatementDetail}
                className="account-settlements-table-row__cell-period--link"
            >
                {dateFrom} {HYPHEN} {dateTo}
            </Link>
        );

        let tableRow;

        if (immScreen.get('isMobile')) {
            tableRow = (
                <OKTableRow id={id}>
                    <OKTableCell className="account-settlements-table-row__cell-period">
                        <p className="account-settlements-table-row__paragraph-mobile account-settlements-table-row__paragraph-mobile--bold">
                            {dateLink}
                        </p>
                        <p className="account-settlements-table-row__paragraph-mobile account-settlements-table-row__paragraph-mobile--no-margin">
                            <FormattedText
                                value="accountSettlements-dueAmount"
                                format="firstUppercase"
                            />
                        </p>
                        <p className="account-settlements-table-row__paragraph-mobile account-settlements-table-row__paragraph-mobile--no-margin">
                            <FormattedText
                                value="accountSettlements-creditAmount"
                                format="firstUppercase"
                            />
                        </p>
                    </OKTableCell>
                    <OKTableCell className="account-settlements-table-row__cell-amount account-settlements-table-row__cell-amount--mobile">
                        <p className="account-settlements-table-row__paragraph-mobile"></p>
                        <p className="account-settlements-table-row__paragraph-mobile account-settlements-table-row__paragraph-mobile--bold account-settlements-table-row__paragraph-mobile--no-margin">
                            {dueAmount}
                        </p>
                        <p className="account-settlements-table-row__paragraph-mobile account-settlements-table-row__paragraph-mobile--bold account-settlements-table-row__paragraph-mobile--no-margin">
                            {creditAmount}
                        </p>
                    </OKTableCell>
                </OKTableRow>
            );
        } else {
            tableRow = (
                <OKTableRow id={id}>
                    <OKTableCell className="account-settlements-table-row__cell-period">
                        {dateLink}
                    </OKTableCell>
                    <OKTableCell className="account-settlements-table-row__cell-amount">
                        {dueAmount}
                    </OKTableCell>
                    <OKTableCell className="account-settlements-table-row__cell-amount">
                        {creditAmount}
                    </OKTableCell>
                </OKTableRow>
            );
        }

        return tableRow;
    }
}

AccountSettlementsTableRow.propTypes = {
    immTransaction: PropTypes.object,
    id: PropTypes.string,
    onRowClick: PropTypes.func,
    originCountry: PropTypes.string
}

AccountSettlementsTableRow.defaultProps = {
    className: '',
    onRowClick: function() {}
}

AccountSettlementsTableRow.propTypes = {
    immScreen: PropTypes.object,
};

module.exports.constructor = AccountSettlementsTableRow;
module.exports.AccountSettlementsTableRow = connect(
    state => ({
        immScreen: state.screen,
        originCountry: state.profile.get('originCountry')
    }),
    null
)(AccountSettlementsTableRow);